module.exports = __webpack_public_path__ + "img/qrcode-scan.27ddfdfe.png";